export function buildProductOfItem(products, item) {
  if (item.productId != "UNCATEGORIZED") {
    return  products[item.productId]
  } else {
    return  Object.assign({}, { price: item.price, taxAmount: 0 })
  }
}

export function calcItemPrice(item, product, quantity) {
  let amount = product.price * quantity, taxAmount = product.taxAmount * quantity

  if (item.discount && product.price > 0) {
    const discountType = item.discount.type
    const discountAmount = item.discount.amount

    if (discountType == "percentage") {
      const percent = (100 - discountAmount) / 100
      amount = amount * percent
      taxAmount = taxAmount * percent
    } else {
      const ratio = product.taxAmount / product.price
      amount = amount - discountAmount
      taxAmount = amount * ratio
    }
  }
  return { amount, taxAmount }
}

export function calculateCart(cart, products) {
  const discount = cart.discount || {}
  let amountWithoutTax = 0, taxAmount = 0;
  cart.items.map(item => {
    const product = buildProductOfItem(products, item)
    const quantity = item.quantity || 1;
    
    const itemPrice = calcItemPrice(item, product, quantity)
    amountWithoutTax += itemPrice.amount
    taxAmount += itemPrice.taxAmount
  });
  if (cart.reservationId) {
    amountWithoutTax += cart.reservationPrice;
    taxAmount += cart.reservationTaxRate * cart.reservationPrice;
  }
  if (amountWithoutTax > 0 && discount.amount > 0) {
    if (discount.type == "percentage") {
      const percent = (100 - discount.amount) / 100
      amountWithoutTax = amountWithoutTax * percent
      taxAmount = taxAmount * percent
    } else {
      amountWithoutTax = amountWithoutTax - discount.amount
    }
  }
  let totalPrice = amountWithoutTax + taxAmount;
  const shop = window.App.shop || {fee_percent: 0, fee_amount: 0}
  var appFee = totalPrice * parseFloat(shop.fee_percent) / 100.0 + parseFloat(shop.fee_amount)
  var appFeeInPrice = totalPrice * parseFloat(shop.fee_percent_in_price) / 100.0 + parseFloat(shop.fee_amount_in_price)
  if (cart.reservationId == null && shop.different_fee_if && amountWithoutTax >= shop.trigger_price) {
    appFee = amountWithoutTax * (shop.trigger_price_out_of_price / 100)
    appFeeInPrice = amountWithoutTax * (shop.trigger_price_in_price / 100)
  }
  return {
    amountWithoutTax: round2(amountWithoutTax),
    totalPrice: round2(totalPrice),
    taxAndFeeAmount: round2(taxAmount) + round2(appFee),
    totalAmount: round2(totalPrice) + round2(appFee),
    appFee: round2(appFee),
    appFeeInPrice: round2(appFeeInPrice)
  }
}

export function collectOrderData(currentShop) {
  const cart = currentShop.cart
  const discount = currentShop.cart.discount
  const shopId = currentShop.entity.id
  const playerData = {
    id: cart.player.id,
    first_name: cart.player.firstName,
    last_name: cart.player.lastName,
    phone: cart.player.phone,
    email: cart.player.email,
    country_code: cart.player.countryCode
  }
  return {
    order: {
      player: playerData,
      player_reservation_id: cart.playerReservationId,
      reservation_id: cart.reservationId,
      reservation_net_amount: cart.reservationPrice,
      shop_id: shopId,
      discount: {type: discount.type,  amount: discount.amount},
      products: currentShop.cart.items.map(item => (
        {id: item.productId, quantity: item.quantity, price: item.price, discount: item.discount}
      ))
    }
  }
}

export function caclulateFee(fees, amount) {
  var fee = amount * parseFloat(fees.feePercent) / 100.0 + parseFloat(fees.feeAmount)
  var feeInPrice = amount * parseFloat(fees.feePercentInPrice) / 100.0 + parseFloat(fees.feeAmountInPrice)
  if (fees.differentFeeIf && amount >= fees.triggerPrice) {
    fee = amount * (fees.triggerPriceOutOfPrice / 100)
    feeInPrice = amount * (fees.triggerPriceInPrice / 100)
  }
  return {
    fee,
    feeInPrice
  }
}

function round2(value) {
  return Math.round(value * 100) / 100
}
